import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局配置axios文件
import api from '@/axios/api.js'
Vue.prototype.$api = api

// 全局配置axios接口文件
import gd from '@/axios/apiData.js'
Vue.prototype.$gd = gd

//引入格式化时间格式
import moment from "@/utils/moment/moment.min" // 时间格式
Vue.prototype.$moment = moment

import VueParticles from 'vue-particles'
Vue.use(VueParticles)


//引入公共样式
import  '@/styles/common.scss'

//引入iconfont
import '@/assets/iconfont/iconfont.css'

//引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入MD5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

//引入elementUI
import 'element-ui/lib/theme-chalk/index.css'
import {
	Button as ElButton,
	Container as ElContainer,
	Header as ElHeader,
	Footer as ElFooter,
	Main as ElMain,
	Form as ElForm,
	FormItem as ElFormItem,
	Input as ElInput,
	Cascader as ElCascader,
	CascaderPanel as ElCascaderPanel,
	Upload as ElUpload,
	Icon as ElIcon,
	Dialog as ElDialog,
	Select as ElSelect,
	Option as ElOption,
	Divider as ElDivider,
	Loading as ElLoading,
	Menu as ElMenu,
	Submenu as ElSubmenu,
	MenuItem as ElMenuItem,
	MenuItemGroup as ElMenuItemGroup,
	Aside as ElAside,
	Dropdown as ElDropdown,
	DropdownMenu as ElDropdownMenu,
	DropdownItem as ElDropdownItem,
	Table as ElTable,
	TableColumn as ElTableColumn,
	Pagination as ElPagination,
	ButtonGroup as ElButtonGroup,
	DatePicker as ElDatePicker,
	Tabs as ElTab,
	TabPane as ElTabPane,
	Image as ElImage,
	Popconfirm as ElPopconfirm,
	Popover as ElPopover,
	Switch as ElSwitch,
	Checkbox as ElCheckbox,
	CheckboxButton as ElCheckboxButton,
	CheckboxGroup as ElCheckboxGroup,
	Link as ElLink,
	Empty as ElEmpty,
	Radio as ElRadio,
	RadioGroup as ElRadioGroup,
	RadioButton as ElRadioButton,
	Tag as ElTag,
	Steps as ElSteps,
	Step as ElStep,
	Descriptions as ElDescriptions,
	DescriptionsItem as ElDescriptionsItem,
	Alert as ElAlert,
	MessageBox as ElMessageBox,
	Message as ElMessage,
	Carousel as ElCarousel,
	CarouselItem as ElCarouselItem,
	Card as ElCard,
	Tree as ElTree,
	Badge as ElBadge,
	InputNumber as ElInputNumber,
	Col as ElCol,
	Row as ElRow
} from 'element-ui';
//解决按需引入message 自动触发的问题
Vue.prototype.$message = ElMessage;
Vue.prototype.$messageBox = ElMessageBox

const elementModule = {
	ElCol,
	ElRow,
	ElInputNumber,
	ElCheckboxButton,
	ElCheckboxGroup,
	ElTree,
	ElCard,
	ElCarousel,
	ElCarouselItem,
	ElAlert,
	ElButton,
	ElContainer,
	ElHeader,
	ElMain,
	ElFooter,
	ElForm,
	ElFormItem,
	ElInput,
	ElCascader,
	ElCascaderPanel,
	ElUpload,
	ElIcon,
	ElDialog,
	ElSelect,
	ElOption,
	ElDivider,
	ElLoading,
	ElMenu,
	ElSubmenu,
	ElMenuItem,
	ElMenuItemGroup,
	ElAside,
	ElDropdown,
	ElDropdownMenu,
	ElDropdownItem,
	ElTable,
	ElTableColumn,
	ElPagination,
	ElButtonGroup,
	ElDatePicker,
	ElTab,
	ElTabPane,
	ElImage,
	ElPopconfirm,
	ElPopover,
	ElSwitch,
	ElCheckbox,
	ElLink,
	ElEmpty,
	ElRadio,
	ElRadioGroup,
	ElRadioButton,
	ElTag,
	ElSteps,
	ElStep,
	ElDescriptions,
	ElDescriptionsItem,
	ElBadge
};

Object.keys(elementModule).forEach(key => {
  Vue.use(elementModule[key]);
})

Vue.config.productionTip = false

var vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vue
